import request from '@/api/fetcher/request'
import { loadToken, loadUserInfo } from '@/utils/cache'
import { WEB_VERSION } from '@/config/config'
import Cookie from 'js-cookie'

export enum PayChannel {
    /** 微信 */
    WX = 1,
    /** 支付宝 */
    ALI = 2,
}

/**
 * 页面枚举
 */
export enum Pages {
    Home = 0,
    PdfHome = 1,
    AdCharge = 26,
    /** 红包活动 */
    CompRedbag = 67,
    /** 终身VIP活动 */
    LifelongVipDiscount = 68,
    /** 公众号支付 */
    OfficialAccounts = 2,
    /** 全文翻译会员中心 */
    Translate = 3,
}

export enum PayType {
    /** 微信内调起 jsapi 支付 */
    wx_web = 'wx_web',
    /** 微信二维码支付 */
    wx_qrcode = 'wx_qrcode',
    /** 支付宝二维码支付 */
    alipay_qrcode = 'alipay_qrcode',
    /** 微信应用支付 */
    wx_app = 'wx_app',
}

export enum UnitForm {
    /** 极光pdf权益套餐 */
    PDF = 1,
    /** 极光pdf权益套餐 */
    DUBA = 2,
}

export interface PayParams {
    /** 支付配置套餐Id */
    pay_setting_id: number;
    /** 支付来源 */
    pay_from: Pages;
    /** 支付渠道 */
    pay_channel: PayChannel;
    /** 界面展示来源 */
    show_from: number;
    /** 支付类型 */
    pay_type: PayType;
    /**
     * 产品自定义字段
     */
    order_from?: number;
    /** 0-默认值 */
    uni_from?: UnitForm;
    /** 安装时间戳 */
    install_time_sec?: number;
    /** 安装天数 */
    install_days?: number;
    /**
     * 微信授权时拿到的 code 值
     * @description 支付方式为 wx_web 时有效
     */
    wx_oauth_code?: string;
}

export interface AppPayRes {
  /** 微信的app_id */
  appid: string
  /** 商户号 */
  partnerid: string
  prepayid: string
}

export interface OrderInfo {
  address_id?: number
  /** wx_app时返回,用于调起微信 */
  app_pay_res?: AppPayRes
  /** 纯签约跳转地址 */
  entrust_url?: string
  id?: string
  /** wx_app时也需要用到 */
  nonce_str?: string
  /** 订单id */
  order_id?: string
  /** wx_app时也需要用到 */
  package?: string
  /** wx_app时也需要用到 */
  pay_sign?: string
  sign_type?: string
  /** wx_app时也需要用到 */
  time_stamp?: string
  url?: string
}

export function getCommon () {
  // @ts-ignore
  const { subpid: spid = 0, fid: function_id = 0 } = window.app.$TidObj || {}
  return {
    token: loadToken(),
    open_id: loadUserInfo() ? loadUserInfo().open_id : '',
    server_id: Cookie.get('svrid') || '',
    uuid: Cookie.get('uuid') || '',
    tryno: Cookie.get('tryno') || '',
    user_agent: 'web',
    web_version: WEB_VERSION,
    vip_version: Cookie.get('vip_version'),
    func_id: Cookie.get('func_id') || '',
    // @ts-ignore
    tid1: window.app.$TidObj.tid1 || 0,
    // @ts-ignore
    tid2: window.app.$TidObj.tid2 || 0,
    // @ts-ignore
    tod1: window.app.$TidObj.tod1 || 0,
    // @ts-ignore
    tod2: window.app.$TidObj.tod2 || 0,
    spid,
    function_id,
    pid: 13
  }
}

export function genH5PayUrl (params: PayParams) {
  const rawUrl = `${location.origin}/${location.pathname.split('/')[1]}/h5pay/`
  const common = getCommon()
  params.pay_type = PayType.wx_web
  const url = `${rawUrl}?payParams=${encodeURIComponent(JSON.stringify(params))}&common=${encodeURIComponent(JSON.stringify(common))}&t=${new Date().getTime()}`
  return genShortLink(url)
}

export function genH5PageUrl (certificate: string) {
  const rawUrl = `${location.origin}/${location.pathname.split('/')[1]}/h5pay/`
  return `${rawUrl}?cert_id=${encodeURIComponent(certificate)}`
}

export function genMidasPayUrl (certificate: string) {
  return `${location.origin}/${location.pathname.split('/')[1]}/midaspay/?cert_id=${encodeURIComponent(certificate)}`
}

/**
 * 生成短链
 * @param url
 * @returns
 */
export function genShortLink (url: string) {
  return request.post('/api/sdk/url/shortable', {
    url,
  }) as unknown as Promise<{short_url: string}>
}

/**
 * 创建支付订单
 * @param data
 * @returns
 */
export function createPayOrder (data: PayParams, common) {
  return request.post('/api/sdk/service/pay', {
    ...data,
    common
  }) as unknown as Promise<OrderInfo & { resp_common: { ret: number}}>
}